import React from 'react';
import { connect } from 'react-redux';
import { block } from 'scy/display.mod.scss';
import { PrimaryButton, SecondaryButton } from 'scy/buttons';
import Switch from 'components/ui/switch/Switch';
import { width100 } from 'scy/utils.mod.scss';
import border from 'scy/border.mod.scss';
import RoundupRow from './RoundUpRow';
import RoundUpRowCollapsed from './roundUpRowCollapsed';
import Organizations from './Organizations';
import classnames from 'classnames';

import { getUserRoundUpData } from './actions';
import { restore } from '../cart/actions';

class RoundUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOrgs: false,
      orgName: '',
      roundUpEnabled: false,
      roundUpOrgID: '',
      showRoundUpStatement: false,
      roundUpAmount: 0
    };
  }

  componentDidMount() {
    const { restore } = this.props;
    this.handleUpdatingUserRoundUpInfo(() => {
      // Callback that displays round up line item
      restore(true);
    });
  }

  handleUpdatingUserRoundUpInfo(cb) {
    const { getUserRoundUpData, isCheckoutPage } = this.props;
    getUserRoundUpData().then(res => {
      const roundUpEnabled = res.roundUpEnabled;
      const roundUpOrgID = res.roundUpOrgId;
      const roundUpAmount = res.roundUpAmount;
      this.selectOrgNameFromId(roundUpOrgID);
      this.setState({
        roundUpEnabled,
        roundUpOrgID,
        roundUpAmount,
        showOrgs: roundUpEnabled
      });
      // fire callback on checkout and round up true to restore() cart with round up line item
      if (cb && isCheckoutPage && roundUpEnabled) cb();
    });
  }

  selectOrgNameFromId = id => {
    const { roundUpOrgs } = this.props;
    const found = roundUpOrgs.find(element => element.id === id);
    if (found && found.name) {
      this.setOrgName(found.name);
    }
  };

  setRoundUpEnabled = roundUpEnabled => {
    this.setState({ roundUpEnabled });
  };
  setShowOrgs = showOrgs => {
    this.setState({ showOrgs });
  };
  setOrgName = orgName => {
    this.setState({ orgName });
  };
  setRoundUpOrgID = roundUpOrgID => {
    this.setState({ roundUpOrgID });
  };
  setshowRoundUpStatement = showRoundUpStatement => {
    this.setState({ showRoundUpStatement });
  };

  handleSwitchToggle = toggle => {
    const { updateUser, restore, isCheckoutPage } = this.props;
    const data = {
      roundUpEnabled: !toggle
    };
    this.setRoundUpEnabled(!toggle);
    this.setShowOrgs(!toggle);
    // Update user data in Parse then set redux store and component state
    updateUser(data).then(this.handleUpdatingUserRoundUpInfo(null));
    // Update cart line Item to reflect round up if true - checkout page only
    if (isCheckoutPage) {
      restore(!toggle);
    }
  };

  submitNewRoundUpOrganization = id => {
    const { roundUpOrgID } = this.state;
    const { updateUser } = this.props;
    const data = { roundUpOrgID: id };
    if (id === roundUpOrgID) {
      return;
    }
    updateUser(data).then(this.handleUpdatingUserRoundUpInfo(null));
  };
  render() {
    const {
      showOrgs,
      orgName,
      roundUpEnabled,
      roundUpOrgID,
      showRoundUpStatement,
      roundUpAmount
    } = this.state;
    const { roundUpOrgs, isCheckoutPage } = this.props;

    return (
      <>
        {isCheckoutPage ? (
          <RoundUpRowCollapsed
            setshowRoundUpStatement={this.setshowRoundUpStatement}
            showRoundUpStatement={showRoundUpStatement}
          >
            <Switch
              handleSwitchToggle={this.handleSwitchToggle}
              roundUpEnabled={roundUpEnabled}
            />
          </RoundUpRowCollapsed>
        ) : (
          <RoundupRow label="round up my change" isTopCell>
            <Switch
              handleSwitchToggle={this.handleSwitchToggle}
              roundUpEnabled={roundUpEnabled}
            />
          </RoundupRow>
        )}

        {isCheckoutPage ? (
          <React.Fragment>
            {showOrgs ? (
              <Organizations
                showOrgs={showOrgs}
                orgs={roundUpOrgs}
                roundUpOrgID={roundUpOrgID}
                submitNewRoundUpOrganization={this.submitNewRoundUpOrganization}
              />
            ) : null}
          </React.Fragment>
        ) : (
          <RoundupRow
            className={classnames({
              [block]: showOrgs,
              [border.bottomNone]: showOrgs
            })}
            showOrgs={showOrgs}
            label={`Organization `}
            value={orgName}
          >
            {showOrgs ? (
              <Organizations
                showOrgs={showOrgs}
                orgs={roundUpOrgs}
                roundUpOrgID={roundUpOrgID}
                submitNewRoundUpOrganization={this.submitNewRoundUpOrganization}
              />
            ) : null}
          </RoundupRow>
        )}
        {isCheckoutPage ? null : (
          <React.Fragment>
            <RoundupRow
              label="total to date"
              value={roundUpAmount.toString()}
            />
            <RoundupRow isBottomCell>
              <div className="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-0">
                {!showOrgs ? (
                  <SecondaryButton
                    onClick={() => {
                      this.setShowOrgs(!showOrgs);
                    }}
                    className={width100}
                  >
                    edit
                  </SecondaryButton>
                ) : (
                  <PrimaryButton
                    onClick={() => {
                      this.setShowOrgs(!showOrgs);
                    }}
                    className={width100}
                  >
                    save
                  </PrimaryButton>
                )}
              </div>
            </RoundupRow>
          </React.Fragment>
        )}
      </>
    );
  }
}

const ConnectedRoundUp = connect(
  state => ({
    roundUpOrgs:
      state.roundUp && state.roundUp.organizations
        ? state.roundUp.organizations
        : []
  }),
  { getUserRoundUpData, restore }
)(RoundUp);

export default ConnectedRoundUp;
